import { IMyOrdersWidgetData } from "@pageBuilder/typings";
import { MyOrdersWidgetScriptRenderer } from "./my-orders-widget-script.renderer";
import { WidgetRendererBase } from "../widget-renderer-base";
import { IRenderingCommonContext } from "@commonRendering/types";

export class MyOrdersWidgetRenderer extends WidgetRendererBase<IMyOrdersWidgetData> {

    private readonly scriptRenderer: MyOrdersWidgetScriptRenderer;

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.scriptRenderer = new MyOrdersWidgetScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("myOrdersWidget");
    }

    protected renderInternal(element: HTMLElement): HTMLElement {
        const name = document.createElement("div");
        name.classList.add("name");

        const itemGroup = document.createElement("div");
        itemGroup.classList.add("itemgroup");

        const content = element.querySelector(".widget-content");
        content?.replaceChildren(name, itemGroup);
        this.scriptRenderer.renderCommon(this.renderedDocument);
        this.scriptRenderer.renderLocal(element);

        if (this.isEditorRendering || this.isPreviewRendering) {
            element.setAttribute("data-draft", "true");
        }

        return element;
    }

    protected override renderStyles(): void {
        //nothing
    }

    protected getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [`#${element.id}`, `#${element.id} .title`, `#${element.id} .description`, `#${element.id} .item-container`, `#${element.id} .item-icon`, `#${element.id} .header`, `#${element.id} .itemgroup`];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        // nothing
    }

}
